import { render, staticRenderFns } from "./ProjectExternalLayoutDetails.vue?vue&type=template&id=27ee04de"
import script from "./ProjectExternalLayoutDetails.vue?vue&type=script&lang=js"
export * from "./ProjectExternalLayoutDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports